import clientLogo1 from "@/assets/client-logo/Logo 1.png";
import clientLogo2 from "@/assets/client-logo/Logo 2.png";
import clientLogo3 from "@/assets/client-logo/Logo 3.png";
import clientLogo4 from "@/assets/client-logo/Logo 4.png";

const clientLogos = [
  { src: clientLogo1, alt: "SMOOR" },
  { src: clientLogo2, alt: "D'CreativeEdge Gifting Solutions" },
  { src: clientLogo3, alt: "Splitkart client" },
  { src: clientLogo4, alt: "My Cravee" },
];

export function ClientLogos() {
  return (
    <section aria-labelledby="our-clients-heading" className="border-y border-border bg-surface py-8 md:py-10">
      <div className="container-tight">
        <h2
          id="our-clients-heading"
          className="text-center text-sm font-semibold uppercase tracking-[0.18em] text-muted-foreground"
        >
          Our Clients
        </h2>
        <div className="mt-6 grid grid-cols-2 overflow-hidden rounded-2xl border border-border bg-background md:grid-cols-4">
          {clientLogos.map((logo, index) => (
            <div
              key={logo.src}
              className={`flex h-28 items-center justify-center p-5 md:h-32 md:p-7 ${
                index % 2 === 0 ? "border-r border-border" : ""
              } ${index < 2 ? "border-b border-border md:border-b-0" : ""} ${
                index > 0 ? "md:border-l md:border-border" : ""
              } md:border-r-0`}
            >
              <img src={logo.src} alt={logo.alt} className="max-h-16 w-full max-w-[13rem] object-contain md:max-h-20" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
